










































































































































































import Vue from "vue";
import ThemeImg from "@/components/ThemeImg.vue";
import SessionListItem from "./SessionListItem.vue";
import { computed, onMounted, reactive, ref } from "@vue/composition-api";
import { ScanSession, ScanSessionStatus } from "../../data/model";
import { SessionConnectionFilters } from "./SourceDetailsModal.vue";
import DropDown from "@/components/dropdown/DropDown.vue";
export default Vue.extend({
  components: {
    ThemeImg,
    SessionListItem,
    DropDown,
  },
  props: [
    "sessions",
    "connection_filters",
    "selected_id",
    "hide_actions",
    "has_session_params",
  ],

  setup(props) {
    const current_filter = ref("");
    const set_current_filter = (filter: string) => {
      current_filter.value = filter;
      setTimeout(() => {
        const input = document.querySelector("[role=filter-input]");
        if (input) {
          (input as HTMLInputElement).focus();
        }
      }, 200);
    };
    // filters
    const filters = reactive({
      name: "",
      connection: "",
      start_at: "",
      end_at: "",
      status: [
        {
          id: "Cancelled" as ScanSessionStatus,
          name: "Cancelled",
          checked: false,
        },
        {
          id: "Opened" as ScanSessionStatus,
          name: "Running",
          checked: false,
        },
        {
          id: "Closed" as ScanSessionStatus,
          name: "Completed",
          checked: false,
        },
      ] as any[],
    });

    const display_filters = computed(() => {
      return Object.entries(filters).reduce((acc, [k, v]) => {
        const is_array_and_ok =
          Array.isArray(v) && v.filter((d) => d.checked).length > 0;
        const is_str_and_ok = !Array.isArray(v) && v.length > 0;
        if (is_array_and_ok || is_str_and_ok) {
          acc[k] = v;
        }

        return acc;
      }, {} as any);
    });

    const SPECIAL_CHARS = {
      "\\": true,
      "^": true,
      $: true,
      ".": true,
      "|": true,
      "?": true,
      "*": true,
      "+": true,
      "(": true,
      ")": true,
      "[": true,
      "]": true,
      "{": true,
      "}": true,
      "-": true,
    };
    const escape_special_chars = (str: string): string => {
      return str
        .split("")
        .map((d) => {
          if (d in SPECIAL_CHARS) {
            return "\\" + d;
          }
          return d;
        })
        .join("");
    };

    const display_items = computed(() => {
      const name_filter = filters.name
        ? new RegExp(escape_special_chars(filters.name.toLowerCase()), "g")
        : "";

      const connection_filter = filters.connection
        ? new RegExp(
            escape_special_chars(filters.connection.toLowerCase()),
            "g"
          )
        : "";

      return (props.sessions as ScanSession[]).filter((s) => {
        /* if (!s.connectionName || !s.name) {
          return false;
        } */
        if (filters.name && !s.name) {
          return false;
        }
        if (
          filters.name &&
          s.name &&
          !(s.name.toLowerCase().search(name_filter) > -1)
        ) {
          return false;
        }

        if (filters.connection && !s.connectionName) {
          return false;
        }
        if (
          filters.connection &&
          s.connectionName &&
          !(s.connectionName.toLowerCase().search(connection_filter) > -1)
        ) {
          return false;
        }
        if (filters.start_at && !s.startTime.startsWith(filters.start_at)) {
          return false;
        }
        if (filters.end_at && !s.endTime.startsWith(filters.end_at)) {
          return false;
        }
        const statuses = filters.status.filter((f) => f.checked);
        if (
          statuses.length > 0 &&
          !statuses.map((d) => d.id).includes(s.status)
        ) {
          return false;
        }
        return true;
      });
    });

    const on_status_input = (status_input: any) => {
      console.log("on_status_input:", status_input);
    };

    const reset_filter = (k: string) => {
      if (k == "status") {
        filters.status = filters.status.map((d) => {
          d.checked = false;
          return d;
        });
      } else {
        // @ts-ignore
        filters[k] = "";
      }
    };

    onMounted(() => {
      const connection_filters = props.connection_filters as SessionConnectionFilters | null;
      if (connection_filters) {
        filters.connection = connection_filters.connection.name;
        if (connection_filters.session_is_active) {
          filters.status = filters.status.map((s) => {
            s.checked = s.id == "Opened" ? true : false;
            return s;
          });
        } else {
          filters.status = filters.status.map((s) => {
            s.checked = s.id == "Opened" ? false : true;
            return s;
          });
        }
      }
    });
    return {
      filters,
      display_filters,
      current_filter,
      set_current_filter,
      display_items,
      on_status_input,
      reset_filter,
    };
  },
});
